@use "../../styles/breakpoint.module.scss" as *;

.root {
    position: relative;

    &:has([data-carousel-all-visible="false"]) {
        padding-bottom: var(--spacer-24);
    }
}

.scrollContainer {
    composes: safeContainer from "../../styles/composable/layout.module.css";
}

.slideWrapper {
    display: flex;
    gap: var(--spacer-16);

    [data-carousel-all-visible="true"] & {
        justify-content: center;
    }
}

.slideContainer {
    --tiles-visible: var(--tiles-visible-desktop);
    --gutters: calc(var(--tiles-visible) - 1);
    --gutter-space: calc(var(--spacer-16) * var(--gutters));

    width: calc((100% - var(--gutter-space)) / var(--tiles-visible));
    flex-shrink: 0;

    @media ($below-mobile) {
        --tiles-visible: var(--tiles-visible-mobile);
    }
}

.tile {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    position: relative;
    width: 100%;
    aspect-ratio: 1;
    overflow: hidden;
    background-color: var(--gray-700);
}

.picture {
    position: absolute;
    inset: 0;

    &::after {
        content: "";
        position: absolute;
        inset: 0;
        background: var(--overlay-black-gradient);
        pointer-events: none;
    }
}

.image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.label {
    position: relative;
    width: 100%;
    text-align: center;
    z-index: 1;
    font: var(--font-button-16);
    padding-inline: var(--spacer-8);
    padding-bottom: var(--spacer-16);
}

.dots {
    bottom: calc(var(--spacer-8) * -1);
}
